import React from 'react';

export const HelpOutline = ({
  className,
  color,
}: {
  className?: string;
  color?: string;
}) => (
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.2563 16.9302C13.9382 16.9302 16.923 13.9454 16.923 10.2635C16.923 6.58161 13.9382 3.59684 10.2563 3.59684C6.57444 3.59684 3.58967 6.58161 3.58967 10.2635C3.58967 13.9454 6.57444 16.9302 10.2563 16.9302ZM10.2563 18.5968C14.8587 18.5968 18.5897 14.8659 18.5897 10.2635C18.5897 5.66114 14.8587 1.93018 10.2563 1.93018C5.65396 1.93018 1.923 5.66114 1.923 10.2635C1.923 14.8659 5.65396 18.5968 10.2563 18.5968ZM11.0897 14.4302C11.0897 14.8904 10.7166 15.2635 10.2563 15.2635C9.7961 15.2635 9.423 14.8904 9.423 14.4302C9.423 13.9699 9.7961 13.5968 10.2563 13.5968C10.7166 13.5968 11.0897 13.9699 11.0897 14.4302ZM8.58967 9.43018C8.58967 8.82297 8.80909 8.42881 9.09122 8.17802C9.3887 7.91359 9.8089 7.76351 10.2563 7.76351C11.1122 7.76351 11.923 8.4068 11.923 9.43018C11.923 10.4536 11.1122 11.0968 10.2563 11.0968C9.7961 11.0968 9.423 11.4699 9.423 11.9302C9.423 12.3904 9.7961 12.7635 10.2563 12.7635C11.9005 12.7635 13.5897 11.5008 13.5897 9.43018C13.5897 7.35951 11.9005 6.09684 10.2563 6.09684C9.45378 6.09684 8.62398 6.36342 7.98395 6.93233C7.32859 7.51488 6.923 8.37071 6.923 9.43018C6.923 9.89041 7.2961 10.2635 7.75634 10.2635C8.21657 10.2635 8.58967 9.89041 8.58967 9.43018Z"
      fill={color || '#6E6B8C'}
    />
  </svg>
);
